import React from "react";
import { ProviderProps } from "./types";
import { AuthProvider } from "./providers/AuthProvider";
import { NotificationProvider } from "./providers/NotificationProvider";
import { UserProvider } from "./providers/UserProvider";
import { OrderInvitationProvider } from "./providers/OrderInvitationProvider";
import { VolumePriceProvider } from "./providers/VolumePriceProvider";
import { BannerProvider } from "./providers/BannerProvider";

export const AppProvider: React.FC<ProviderProps> = ({ children }) => {
  return (
    <AuthProvider>
      <UserProvider>
        <NotificationProvider>
          <OrderInvitationProvider>
            <VolumePriceProvider>
              <BannerProvider>{children}</BannerProvider>
            </VolumePriceProvider>
          </OrderInvitationProvider>
        </NotificationProvider>
      </UserProvider>
    </AuthProvider>
  );
};
